// src/stone/icons/SecurityShield2X.tsx
import { jsx } from "react/jsx-runtime";
var SecurityShield2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M19.649 2.397a1 1 0 0 1 .702 0l13.334 5a1 1 0 0 1 .648.936V20c0 5.447-3.615 9.867-7.008 12.836a37 37 0 0 1-6.268 4.4 23 23 0 0 1-.563.301l-.033.017-.01.005-.002.001h-.001L20 36.668l-.448.894-.004-.002-.009-.005-.033-.017-.12-.062a34.446 34.446 0 0 1-1.999-1.158 37 37 0 0 1-4.712-3.481C9.282 29.867 5.667 25.446 5.667 20V8.333a1 1 0 0 1 .649-.936zM20 36.667l-.447.894a1 1 0 0 0 .894 0zm0-1.132.089-.05a35.138 35.138 0 0 0 5.92-4.155c3.273-2.864 6.324-6.776 6.324-11.33V9.026L20 4.401 7.667 9.026V20c0 4.554 3.051 8.466 6.325 11.33A35 35 0 0 0 20 35.536" })
  }
);
var SecurityShield2X_default = SecurityShield2X;

export {
  SecurityShield2X_default
};
